// src/modules/inventory/components/InventorySearchBar.tsx
import React from "react";
import { TextField, Select, MenuItem, Box } from "@mui/material";

type Props = {
  value: string;
  onChange: (v: string) => void;
  category: string;
  onCategoryChange: (v: string) => void;
};

const categories = [
  { label: "All", value: "" },
  { label: "Parts", value: "parts" },
  { label: "Tools", value: "tools" },
  { label: "Consumables", value: "consumables" },
  // ...fetch dynamically from backend if needed
];

const InventorySearchBar: React.FC<Props> = ({
  value,
  onChange,
  category,
  onCategoryChange,
}) => (
  <Box className="flex flex-col md:flex-row gap-2 md:gap-4 items-center bg-white text-gray-800 rounded-lg shadow px-4 py-3">
    <TextField
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Search by name, SKU, barcode..."
      aria-label="Search inventory"
      fullWidth
      size="small"
    />
    <Select
      value={category}
      onChange={(e) => onCategoryChange(e.target.value as string)}
      size="small"
      displayEmpty
      sx={{ minWidth: 180 }}
    >
      {categories.map((cat) => (
        <MenuItem key={cat.value} value={cat.value}>
          {cat.label}
        </MenuItem>
      ))}
    </Select>
    {/* Future: Barcode Scan button */}
  </Box>
);

export default InventorySearchBar;
